import { render, staticRenderFns } from "./ui-gold.vue?vue&type=template&id=d446c034&scoped=true&"
import script from "./ui-gold.vue?vue&type=script&lang=js&"
export * from "./ui-gold.vue?vue&type=script&lang=js&"
import style0 from "./ui-gold.vue?vue&type=style&index=0&id=d446c034&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d446c034",
  null
  
)

export default component.exports